export default __webpack_public_path__ + "static/media/completedJob.fd2053b8.svg";